import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => {
	return ( {
		tabsRoot: {
			display       : "flex",
			flexDirection : "column",
			overflow      : "hidden"
		},
		tab: {
			fontWeight       : "500",
			flex             : "1",
			padding          : "1.75rem 1rem",
			borderRadius     : "0",
			color            : theme.other.colors.text.secondary,
			borderWidth      : "0",
			"&[data-active]" : {
				color: theme.other.paletteNew.primaryDarkBlue
			},

			"&[data-active]:after": {
				background   : theme.other.paletteNew.mainGradient,
				content      : "\" \"",
				position     : "absolute",
				bottom       : "0",
				height       : "4px",
				width        : "100%",
				borderRadius : "1rem 1rem 0 0"

			},
			"&:hover": {
				backgroundColor: "transparent"
			}
		},
		tabsList: {
			borderBottom: `1px solid ${ theme.other.colors.border.primary }`
		},
		panel: {
			overflow: "auto"
		}
	} );
} );